<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12" class="text-center mb-4">
            <h5 class='complain-title'>{{ $t('globalTrans.payment') }}</h5>
        </b-col>
        <b-col lg="12" sm="12">
            <b-overlay :show="loading">
            <template>
                <b-row>
                    <b-col class="mt-3" lg="12" sm="12">
                        <div class="text-center">
                            <b-form-radio-group
                            v-model="payment_type_id"
                            :options="paymentTypeList"
                            ></b-form-radio-group>
                        </div>
                        <keep-alive>
                          <span v-if="amount">
                            <component v-bind:is="comp" :amount="amount" :id="id" @clicked="onClickChild"></component>
                          </span>
                        </keep-alive>
                    </b-col>
                </b-row>
                <div class="row mt-4">
                    <div class="col-md-12 text-right">
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-payment')">{{ $t('globalTrans.close') }}</b-button>
                    </div>
                </div>
            </template>
            </b-overlay>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { getSecurityMny } from '../../api/routes'
import PaymentCash from './PaymentCash'
import PaymentCheck from './PaymentCheck'

export default {
  components: {
    PaymentCheck,
    PaymentCash
  },
  props: ['id'],
  data () {
    return {
      comp: 'PaymentCash',
      loading: false,
      payment_type_id: 3,
      amount: 0
    }
  },
  created () {
      if (this.id) {
          this.getSecPayment()
      }
  },
  computed: {
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    }),
    paymentTypeList () {
        return this.productCommonObj.paymentTypeList.filter(item => item.value !== 1)
    }
  },
  watch: {
    payment_type_id: function (n, o) {
        if (n !== o) {
          if (n === 2) {
              this.comp = 'PaymentCheck'
          } else {
              this.comp = 'PaymentCash'
          }
        }
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    onClickChild () {
      this.$bvModal.hide('modal-payment')
    },
    getSecPayment () {
        this.loading = true
        RestApi.getData(productionServiceBaseUrl, getSecurityMny).then(response => {
            if (response.success) {
                this.amount = response.data.amount
                this.loading = false
            }
        })
    }
  }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
</style>
